var _style, _metadata, _g, _g2, _polyline, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 350",
    style: {
      enableBackground: "new 0 0 650 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n\t.st0{fill:#454545;stroke:#454545;stroke-miterlimit:10;}\n\t.st1{fill:#F47C20;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:none;stroke:#454545;stroke-width:20;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#454545;}\n\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", null, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("slicesourcebounds", {
    width: 663.013,
    height: 296,
    x: 212,
    y: 228,
    bottomleftorigin: "true"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 266.8369,
    cy: -61.2405,
    r: 416.4391,
    gradientTransform: "matrix(1 0 0 -0.3097 91.0098 207.5128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6364,
    style: {
      stopColor: "#F6F6F6"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "510.18,122.913 490.848,155.5 449.514,173.5 \t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "546.453,100.648 506.791,113.837 503.402,134.546 523.998,209.949 531.387,220.109 577.008,208.167 \t "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "609.329,301.096 582.848,258.833 564.848,204.167 \t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "536,209.708 505.991,245.537 505.991,245.824 506.61,310.269 \t"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.665,79.072c1.325,1.335,2.916,2.002,4.77,2.002c1.854,0,3.438-0.649,4.741-1.954 c1.303-1.306,1.955-2.906,1.955-4.803c0-1.917-0.643-3.516-1.924-4.802c-1.285-1.285-2.877-1.925-4.772-1.925 c-1.854,0-3.443,0.662-4.77,1.987c-1.325,1.326-1.989,2.904-1.989,4.739S497.34,77.737,498.665,79.072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.074,45.508l-9.889,13.634c0.467-0.08,0.937-0.147,1.405-0.197c0.472-0.051,0.961-0.075,1.468-0.075 c3.795,0,6.842,1.238,9.146,3.715s3.456,5.754,3.456,9.829c0,4.936-1.591,8.984-4.771,12.155 c-3.179,3.172-7.244,4.755-12.199,4.755c-5.074,0-9.112-1.43-12.11-4.296c-2.995-2.864-4.495-6.712-4.495-11.544 c0-3.139,0.858-6.315,2.538-9.557c1.912-3.691,9.959-14.986,15.035-22.004c-1.622-0.255-3.283-0.392-4.979-0.392 c-17.562,0-31.8,14.24-31.8,31.801c0,17.563,14.238,31.801,31.8,31.801s31.802-14.237,31.802-31.801 C531.48,61.358,524.855,50.932,515.074,45.508z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "543.847,115.501 564.848,74.333 520.996,45.5 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "423.514,162.5 423.514,187.5 443.514,181.5 443.514,170.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.4956,
    y1: 262.4006,
    x2: 324.5039,
    y2: 262.4006,
    gradientTransform: "matrix(1 0 0 -1 91.0098 437.4009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC33"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "415.514,157.59 415.514,192.255 89.514,303.666 89.514,46.335 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.5098,
    y1: 262.4006,
    x2: 324.5039,
    y2: 262.4006,
    gradientTransform: "matrix(1 0 0 -1 91.0098 437.4009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4182,
    style: {
      stopColor: "#FFEAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAD05"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "415.514,163.72 415.514,186.181 25.5,258.363 25.5,91.637 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.6be6fb5db41cbdf069384d2fd3ae8968.svg";
export { ForwardRef as ReactComponent };